import React from 'react';
import { Sun, Moon, Contrast } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeSwitcher = () => {
  const { theme, setThemeByName, colors } = useTheme();

  const themes = [
    { id: 'light', name: 'Light', icon: Sun, tooltip: 'Light theme - Best for daytime' },
    { id: 'dark', name: 'Dark', icon: Moon, tooltip: 'Dark theme - Best for low light' },
    { id: 'highContrast', name: 'High Contrast', icon: Contrast, tooltip: 'High contrast - Maximum accessibility' }
  ];

  return (
    <div
      className="flex flex-col sm:flex-row gap-2 sm:gap-3 p-2 sm:p-3 rounded-xl"
      style={{
        backgroundColor: colors.surface,
        border: `1px solid ${colors.border}`
      }}
    >
      {themes.map(({ id, name, icon: Icon, tooltip }) => {
        const isSelected = theme === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setThemeByName(id)}
            title={tooltip}
            className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 text-sm font-medium transition-all duration-200 w-full sm:flex-1 min-w-0 min-h-[44px]"
            style={{
              backgroundColor: isSelected ? colors.primary : 'transparent',
              color: isSelected ? '#fff' : colors.text,
              borderColor: isSelected ? colors.primary : colors.border,
            }}
          >
            <Icon size={18} className="flex-shrink-0" />
            <span className="whitespace-nowrap">{name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ThemeSwitcher;
